




















import { Vue, Component, Prop } from 'vue-property-decorator';
import Wave from '@lib-ui/directives/wave';

@Component({
  name: 'BaseButtonTertiary',
  directives: {
    Wave,
  },
})
export default class BaseButtonTertiary extends Vue {
  @Prop() id: string;
  @Prop({ default: false }) iconAlignRight: boolean;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) active: boolean;

  get buttonId(): string {
    return this.id || `button-${this['_uid']}`;
  }

  get listeners(): Record<string, Function> {
    return {
      ...this.$listeners,
      click: this.handleClick,
    };
  }

  handleClick(event: any) {
    this.$emit('click', event);
  }
}
